export default {
  'rankMember.title': 'Membership rank',
  'rankMember.rankMemberTab': 'Membership rank',
  'rankMember.accumulatedTab': 'Accumulated',
  'rankMember.rankName': 'Rank name',
  'rankMember.accumulatedSponsor': 'Accumulated sponsorship',
  'rankMember.accumulatedPerYear': 'Annual accumulation level',
  'rankMember.placeholder.accumulatedPerYear': 'Enter the accumulation level',
};
